<!-- Migrated from legacy/Plus/Plus/Stories/index.shtml -->

<template>
  <h4>Stories</h4>
  <div class="portraits">
    <div v-for="story in stories" :key="story.title" class="portrait">
      <p>
        <strong>{{ story.author }}</strong> - {{ story.affiliation }}
      </p>
      <h5>{{ story.title }}</h5>
      <a :href="story.image" :title="`${story.author}: ${story.title}`">
        <img :src="story.thumbnail" :alt="story.alt" />
      </a>
      <p>{{ story.text }}</p>
    </div>
  </div>
  <p class="grey">Click on the images to see a larger version</p>
</template>

<script setup>
const stories = [
  {
    author: "Christopher Hammang",
    affiliation: "CSIRO, Sydney",
    title: "The Hungry Microbiome",
    image: "/Plus/Stories/hungry1.jpg",
    thumbnail: "/Plus/Stories/hungry1.jpg",
    alt: "illustration: the hungry microbiome",
    text: "How healthy diet and gut bacteria help prevent cancer"
  },
  {
    author: "Kate Patterson",
    affiliation: "Garvan Institute of Medical Research, Sydney",
    title: "Cancer Is Not One Disease",
    image: "/Plus/Stories/MutatedGuardian.jpg",
    thumbnail: "/Plus/Stories/MutatedGuardian_thumbnail.jpg",
    alt: "illustration: cancer is not one disease",
    text: "About the body's natural defenses against cancer"
  },
  {
    author: "Maja Divjak",
    affiliation: "Walter and Eliza Hall Institute, Melbourne",
    title: "Type 2 Diabetes",
    image: "/Plus/Stories/inflammasomeFinal.jpg",
    thumbnail: "/Plus/Stories/inflammasome.jpg",
    alt: "illustration: the inflammasome",
    text: "How obesity can lead to adult-onset Diabetes"
  }
];
</script>

<style scoped>
h4 {
  font-weight: 600;
  font-size: 1rem;
}
h5 {
  font-weight: 600;
  font-size: 0.95rem;
  margin: 0.3rem 0;
}
.portraits {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 3%;
}
.portrait {
  width: 28%;
  min-width: 200px;
}
.portrait img {
  max-height: 357px;
  max-width: 100%;
  border-radius: 4px;
}
.portrait p {
  font-size: 0.9rem;
}
p.grey {
  color: var(--subtitle-color);
  font-size: 0.85rem;
}
</style>
